<template>
  <div>
    <container-component class="altura-componente-container">
      <v-container fluid grid-list-xl>
        <parametros-cabecalho :dados-gerais="dadosEmpresa"/>
        <div class="mt-5">
          <div class="container-info-separacao">
            <span>Configurações atuais do sistema</span>
          </div>
          <parametros-ver-configuracao-atual
              v-if="parametroAtivo"
              :dados-empresa="dadosEmpresa"
              :parametro-atual="parametroAtivo"
          />
        </div>
        <div class="mt-10">
          <v-btn color="primary" depressed @click="abrirModalAdicionarParametro">Adicionar parâmetro</v-btn>
        </div>
        <div class="mt-5">
          <div class="container-info-separacao">
            <span>Parametros do sistema</span>
          </div>
          <parametros-item v-for="paramItem in dadosEmpresa.items" :key="paramItem.id"
                           :item="paramItem"
                           @acaoSelecionarParametro="ativarParametroSelecionado"
                           @acaoEditarParametro="abrirModalEditarParametro"
                           @acaoRemoverParametro="abrirModalRemoverParametro"
          />
        </div>
      </v-container>
    </container-component>
    <ModalAdicionarParametro
        v-if="modalAdicionarParametro"
        v-model="modalAdicionarParametro"
        @modalAdicionarParametroAcaoFechar="fecharModalAdicionarParametro"
        @modalParametroAcaoFecharAposAtualizar="fecharModalAdicionarParametroAposAtualizar"
    />
    <ModalEditarParametro
        v-if="modalEditarParametro"
        v-model="modalEditarParametro"
        :parametro="parametrosSelecionado"
        @modalEditarParametroAcaoFechar="fecharModalEditarParametro"
        @modalParametroAcaoFecharAposAtualizar="fecharModalEditarParametroAposAtualizar"
    />
    <confirm-modal
        v-if="modalRemoverParametro"
        v-model="modalRemoverParametro"
        @modalAcaoCancelar="fecharModalRemoverParametro"
        @modalAcaoConfirmar="removerParametro"
        :persistencia="false"
        mensagemInicial="Deseja realmente excluir o parâmetro "
        :mensagemMeio="parametrosSelecionado.nomeConfiguracao"
        mensagemFinal="?"/>
  </div>
</template>

<script>
import {actionTypes} from '@/core/constants'
import ContainerComponent from '@/views/components/Container.vue'
import ModalAdicionarParametro from '@/views/pages/configuracao/parametros/ModalAdicionarParametro.vue'
import ConfirmModal from '@/views/components/ConfirmModal.vue'
import ParametrosItem from '@/views/pages/configuracao/parametros/ParametrosItem.vue'
import ModalEditarParametro from '@/views/pages/configuracao/parametros/ModalEditarParametro.vue'
import ParametrosCabecalho from '@/views/pages/configuracao/parametros/ParametrosCabecalho.vue'
import ParametrosVerConfiguracaoAtual from '@/views/pages/configuracao/parametros/ParametrosVerConfiguracaoAtual.vue'

export default {
    name: 'Parametros',
    components: {
        ParametrosVerConfiguracaoAtual,
        ParametrosCabecalho,
        ModalEditarParametro,
        ParametrosItem,
        ConfirmModal,
        ModalAdicionarParametro, ContainerComponent
    },
    data() {
        return {
            modalAdicionarParametro: false,
            modalEditarParametro: false,
            modalRemoverParametro: false,
            dadosEmpresa: {items: []},
            parametroAtivo: null,
            parametrosSelecionado: null,
        }
    },
    async mounted() {
        await this.buscarParametrosConfiguracao()
    },
    methods: {
        async buscarParametrosConfiguracao() {
            this.setMensagemLoading('Buscando parâmetros do sistema...')
            const resposta = await this.$store.dispatch(actionTypes.PARAMETROS.BUSCAR_CONFIGURACOES_SISTEMA)
            if (resposta) {
                this.dadosEmpresa = resposta
                this.parametroAtivo = this.dadosEmpresa.items.length > 0 ? this.dadosEmpresa.items[0] : null
            }
        },
        abrirModalEditarParametro(parametro) {
            this.modalEditarParametro = true
            this.parametrosSelecionado = parametro
        },
        fecharModalEditarParametro() {
            this.modalEditarParametro = false
            this.parametrosSelecionado = null
        },
        async fecharModalEditarParametroAposAtualizar() {
            this.fecharModalEditarParametro()
            await this.recarregarParametros()
        },
        async ativarParametroSelecionado(parametro) {
            this.setMensagemLoading('Ativando parâmetros do sistema...')
            const dados = {
                input: {
                    id: parametro.id,
                    ativo: true,
                    corPrimaria: parametro.corPrimaria,
                    corSecundaria: parametro.corSecundaria,
                    corTerciaria: parametro.corTerciaria
                },
                fotoEmpresa: null
            }
            const resposta = await this.$store.dispatch(actionTypes.PARAMETROS.ATUALIZAR_CONFIGURACAO, dados)
            if (resposta) {
                this.mostrarNotificacaoSucessoDefault()
                await this.recarregarParametros()
            }
        },
        abrirModalAdicionarParametro() {
            this.modalAdicionarParametro = true
        },
        fecharModalAdicionarParametro() {
            this.modalAdicionarParametro = false
        },
        async fecharModalAdicionarParametroAposAtualizar() {
            this.fecharModalAdicionarParametro()
            await this.recarregarParametros()
        },
        abrirModalRemoverParametro(parametro) {
            this.parametrosSelecionado = parametro
            this.modalRemoverParametro = true
        },
        fecharModalRemoverParametro() {
            this.modalRemoverParametro = false
            this.parametrosSelecionado = null
        },
        async removerParametro() {
            this.setMensagemLoading('Removendo configuração...')
            await this.$store.dispatch(actionTypes.PARAMETROS.DELETAR_CONFIGURACAO, this.parametrosSelecionado.id)
            this.fecharModalRemoverParametro()
            this.mostrarNotificacaoSucessoDefault()
            await this.recarregarParametros()
        },
        async recarregarParametros() {
            await this.buscarParametrosConfiguracao()
            await this.configurarParametros()
        }
    }
}

</script>

<style scoped lang="stylus">

.altura-componente-container
  padding-bottom 50px

.container-info-separacao
  border-bottom 1px solid #ddd
  margin-bottom 20px
  font-weight bold
  color var(--theme-primary)

</style>